import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormGroup,
  FormControl,
  FormBuilder,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'anihis-clinical-examination-certificate',
  templateUrl: './clinical-examination-certificate.component.html',
  styleUrls: ['./clinical-examination-certificate.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    TranslocoModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClinicalExaminationCertificateComponent {
  @Output() formChange = new EventEmitter<any>();

  form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      anamnesis: new FormControl(''),
      clinicalFindings: new FormControl(''),
      diagnosis: new FormControl(''),
      therapy: new FormControl(''),
      followUp: new FormControl(''),
      notes: new FormControl(''),
      veterinarianName: new FormControl(''),
    });

    this.form.valueChanges.subscribe((value) => this.formChange.emit(value));
  }

  get anamnesis(): FormControl {
    return this.form.get('anamnesis') as FormControl;
  }

  get clinicalFindings(): FormControl {
    return this.form.get('clinicalFindings') as FormControl;
  }

  get diagnosis(): FormControl {
    return this.form.get('diagnosis') as FormControl;
  }

  get therapy(): FormControl {
    return this.form.get('therapy') as FormControl;
  }

  get followUp(): FormControl {
    return this.form.get('followUp') as FormControl;
  }

  get notes(): FormControl {
    return this.form.get('notes') as FormControl;
  }

  get veterinarianName(): FormControl {
    return this.form.get('veterinarianName') as FormControl;
  }

  // Called by parent dialog when clearing
  clearForm() {
    this.form.reset();
  }
}
